import React, { useEffect, useState } from "react";
import { Box, Button, Divider, FormControl, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography,} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { CatalogoPerfil, useGetCatalogoPerfiles, } from "../../../hooks/catalogosPerfiles/getCatalogoPerfiles";
import { useAddUserAdmin } from "../../../hooks/AdministracionUsuarios/adminUsuarios/addUserAdmin";

import { sanitizarNombre, sanitizarCorreo, validarCorreo, validarNombre, } from "../../../utils/sanitizar";

interface AddAdminUserProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}

const AddAdminUser: React.FC<AddAdminUserProps> = ({
    open,
    onClose,
    onSuccess,
}) => {

    const { perfiles, obtenerCatalogoPerfiles } =
        useGetCatalogoPerfiles();

    const { agregarUsuario, loading } = useAddUserAdmin();

    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [idPerfil, setIdPerfil] = useState<number>(0);

    const [errorNombre, setErrorNombre] = useState("");
    const [errorCorreo, setErrorCorreo] = useState("");

    useEffect(() => {
        if (open) {
            limpiarFormulario();
            obtenerCatalogoPerfiles();
        }
    }, [open]);

    const cerrarModal = () => {
        limpiarFormulario();
        onClose();
    };

    const guardar = async () => {

        setErrorNombre("");
        setErrorCorreo("");

        let existeError = false;

        if (!validarNombre(nombre)) {
            setErrorNombre("Ingresa un nombre válido.");
            existeError = true;
        }

        if (!validarCorreo(correo)) {
            setErrorCorreo("Ingresa un correo válido.");
            existeError = true;
        }

        if (idPerfil === 0) {
            return;
        }

        if (existeError) {
            return;
        }

        const response = await agregarUsuario({
            nombre: nombre.trim(),
            correo: correo.trim(),
            idPerfil,
            estatus: 1,
        });



        if (response) {
            onSuccess?.();
            cerrarModal();
        }

    };

    const limpiarFormulario = () => {

        setNombre("");
        setCorreo("");
        setIdPerfil(0);

        setErrorNombre("");
        setErrorCorreo("");

    };

    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 650,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        Agregar Usuario
                    </Typography>

                    <IconButton onClick={cerrarModal}>
                        <CloseIcon />
                    </IconButton>

                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box
                    display="flex"
                    flexDirection="column"
                    gap={3}
                >

                    <TextField
                        fullWidth
                        label="Nombre"
                        value={nombre}
                        error={Boolean(errorNombre)}
                        helperText={errorNombre}
                        onChange={(e) => {

                            setNombre(
                                sanitizarNombre(e.target.value)
                            );

                            if (errorNombre) {
                                setErrorNombre("");
                            }

                        }}
                    />

                    <TextField
                        fullWidth
                        label="Correo electrónico"
                        value={correo}
                        error={Boolean(errorCorreo)}
                        helperText={errorCorreo}
                        onChange={(e) => {

                            setCorreo(
                                sanitizarCorreo(e.target.value)
                            );

                            if (errorCorreo) {
                                setErrorCorreo("");
                            }

                        }}
                    />

                    <FormControl fullWidth>

                        <InputLabel>
                            Perfil
                        </InputLabel>

                        <Select
                            value={idPerfil}
                            label="Perfil"
                            onChange={(e) =>
                                setIdPerfil(Number(e.target.value))
                            }
                        >

                            {
                                perfiles.map((perfil: CatalogoPerfil) => (

                                    <MenuItem
                                        key={perfil.id}
                                        value={perfil.id}
                                    >
                                        {perfil.nombre}
                                    </MenuItem>

                                ))
                            }

                        </Select>

                    </FormControl>


                </Box>

                <Divider sx={{ my: 3 }} />

                <Box
                    display="flex"
                    justifyContent="flex-end"
                    gap={2}
                >

                    <Button
                        variant="contained"
                        onClick={cerrarModal}
                        sx={{
                            bgcolor: "#F70083",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#D60072",
                            },
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        onClick={guardar}
                        disabled={
                            loading ||
                            !validarNombre(nombre) ||
                            !validarCorreo(correo) ||
                            idPerfil === 0
                        }
                        sx={{
                            bgcolor: "#2e7d32",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#1b5e20",
                            },
                        }}
                    >
                        {loading ? "Guardando..." : "Guardar Usuario"}
                    </Button>

                </Box>

            </Box>

        </Modal>

    );

};

export default AddAdminUser;